import { withApiContext, withLabelsContext, withUserContext } from "context";
import { IconBotSimplifi } from "Icons";
import { useTheme } from "styled-components";
import React, { useState } from "react";
import SimplifiBot from "./panels/SimplifiBot";

function Bot() {
    const theme = useTheme();
    const [chatBot, setChatBot] = useState(false);

    const handleBot = () => {
        setChatBot((prevState) => !prevState); 
    };

     const handleClose = () => {
     setChatBot(false);
    };

    const renderChatBot = () => {
        return (
            <>
        <SimplifiBot 
        chatBot = {chatBot}
        onClose={handleClose}
        />
        </>
        )
    };

    return (
        <>
            <div onClick={handleBot}>
              {!chatBot &&  <IconBotSimplifi /> }
            </div>
            {chatBot && renderChatBot()}
        </>
    );
}

export default withLabelsContext(
    withApiContext(withUserContext(Bot))
);
